import CustomButton from "components/CustomButton/CustomButton";
import SpaceDialogAction from "../SpaceDialogAction";

const DialogStudentAlreadyAdded = ({
	dialog, studentsSelectedToUse
}) => {
	const student = studentsSelectedToUse[0];
	return (
		<SpaceDialogAction
			dialog={dialog}
			title={`No se puede agregar a ${student.id} (${student.name})`}
			content="Porque ya forma parte de la misma reserva.">
			<CustomButton
				width="120px"
				text="Cerrar"
				onClick={dialog.hide} />
		</SpaceDialogAction>
	);
}

export default DialogStudentAlreadyAdded;